import React, { useContext, useEffect, useState } from 'react';
import './Sidebar.scss';
import { useAuth } from '../../../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import { MdDashboard, MdSell, MdOutlineKeyboardArrowRight, MdLogout, MdPerson2, MdInfo, MdHome } from "react-icons/md";
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

function Sidebar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const [activeTab, setActiveTab] = useState(0);
    const [isToggleSubmenu, setIsToggleSubmenu] = useState(false);

    const getActiveTabFromUrl = (pathname) => {
        if (pathname.startsWith('/dashboard/anuncios') || pathname.startsWith('/dashboard/anuncio/novo') || pathname.startsWith('/dashboard/anuncio')) {
            return 1; // Corresponde à aba 'Anúncios'
        }
        if (pathname.startsWith('/dashboard/usuarios') || pathname.startsWith('/dashboard/usuario/novo') || pathname.startsWith('/dashboard/usuario/conta')) {
            return 2; // Corresponde à aba 'Usuários'
        }
        if (pathname.startsWith('/dashboard/logs')) {
            return 3; // Corresponde à aba 'Logs'
        }

        // Se nenhuma corresponder ou for a base do dashboard
        return 0; // Padrão para 'Dashboard'
    };

    useEffect(() => {
        // Dispara quando a URL muda
        const currentActiveTab = getActiveTabFromUrl(location.pathname);
        setActiveTab(currentActiveTab);

        // Se a aba atual tem um submenu, garante que ele esteja aberto
        if ([1, 2, 3].includes(currentActiveTab)) { // 1: Anúncios, 2: Usuários, 3: Logs
            setIsToggleSubmenu(true);
        } else {
            setIsToggleSubmenu(false); // Fecha o submenu se a aba ativa não tiver um
        }
    }, [location.pathname]);

    const handleClick = (num) => {
        if (num !== activeTab) {
            setActiveTab(num);
            setIsToggleSubmenu(false);
        }
    }

    const handleSubmenu = (num) => {
        setActiveTab(num);

        if (activeTab === num) {
            setIsToggleSubmenu(!isToggleSubmenu);
        } else {
            setIsToggleSubmenu(true);
        }
    }

    const handleLogout = async () => {
        try {
            const res = await logout();
            if (res && res.status === 200) {
                toast.success(`${res.data.msg}`);
                setTimeout(() => navigate('/login'), 1000);
            } else {
                toast.error(`Falha no logout: ${res?.data?.msg || 'Status inesperado.'}`);
            }
        } catch (err) {
            const errorMessage = err.response?.data?.msg || 'Erro inesperado ao fazer logout.';
            toast.error(`Erro ao fazer logout: ${errorMessage}`);
        }
    }

    return (
        <>
            <div className='sidebar'>
                <ul>
                    <li>
                        <Link to='/dashboard'>
                            <Button
                                color='primary black'
                                className={`w-100 ${activeTab === 0 ? 'active' : ''}`}
                            >
                                <span className='icon'><MdDashboard /></span>
                                Dashboard
                            </Button>
                        </Link>
                    </li>
                    <li>
                        <Button
                            color='primary black'
                            className={`w-100 ${activeTab === 1 && isToggleSubmenu ? 'active' : ''}`}
                            onClick={() => handleSubmenu(1)}
                        >
                            <span className='icon'><MdSell /></span>
                            Anúncios
                            <span className='arrow'><MdOutlineKeyboardArrowRight /></span>
                        </Button>
                        <div className={`submenuWrapper ${activeTab === 1 && isToggleSubmenu ? 'colapse' : 'colapsed'}`}>
                            <ul className='submenu'>
                                <li>
                                    <Link to='/dashboard/anuncios' onClick={() => handleClick(1)}>Ver anúncios</Link>
                                </li>
                                <li>
                                    <Link to='/dashboard/anuncio/novo' onClick={() => handleClick(1)}>Novo anúncio</Link>
                                </li>
                            </ul>
                        </div>
                    </li>
                    {user.acesso && (
                        <li>
                            <Button
                                color='primary black'
                                className={`w-100 ${activeTab === 2 && isToggleSubmenu ? 'active' : ''}`}
                                onClick={() => handleSubmenu(2)}
                            >
                                <span className='icon'><MdPerson2 /></span>
                                Usuários
                                <span className='arrow'><MdOutlineKeyboardArrowRight /></span>
                            </Button>
                            <div className={`submenuWrapper ${activeTab === 2 && isToggleSubmenu ? 'colapse' : 'colapsed'}`}>
                                <ul className='submenu'>
                                    <li>
                                        <Link to='/dashboard/usuarios' onClick={() => handleClick(2)}>Ver usuários</Link>
                                    </li>
                                    <li>
                                        <Link to='/dashboard/usuario/novo' onClick={() => handleClick(2)}>Novo usuário</Link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    )}
                    {user.acesso && (
                        <li>
                            <Button
                                color='primary black'
                                className={`w-100 ${activeTab === 3 && isToggleSubmenu ? 'active' : ''}`}
                                onClick={() => handleSubmenu(3)}
                            >
                                <span className='icon'><MdInfo /></span>
                                Logs
                                <span className='arrow'><MdOutlineKeyboardArrowRight /></span>
                            </Button>
                            <div className={`submenuWrapper ${activeTab === 3 && isToggleSubmenu ? 'colapse' : 'colapsed'}`}>
                                <ul className='submenu'>
                                    <li>
                                        <Link to='/dashboard/logs/acessos' onClick={() => handleClick(3)}>Logs acessos</Link>
                                    </li>
                                    <li>
                                        <Link to='/dashboard/logs/erros' onClick={() => handleClick(3)}>Logs erros</Link>
                                    </li>
                                    <li>
                                        <Link to='/dashboard/logs/formularios' onClick={() => handleClick(3)}>Logs formulários</Link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    )}
                    <li>
                        <Link to='/'>
                            <Button
                                color='primary black'
                                className={`w-100 ${activeTab === 4 ? 'active' : ''}`}
                            >
                                <span className='icon'><MdHome /></span>
                                Site
                            </Button>
                        </Link>
                    </li>
                </ul>

                <br />

                <div className='logoutWrapper'>
                    <div className='logoutBox'>
                        <Button
                            variant='contained'
                            onClick={handleLogout}
                        ><MdLogout /> Sair</Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Sidebar;
